<template>
	<footer class="footer">
		<p class="footer__help">{{ $t("footer1") }}</p>
		<p class="footer__callus">{{ $t("footer2") }}</p>
		<a class="footer__tel" :href="telephoneUrl">{{
			$t("contactPhoneNumber")
		}}</a>
		<a class="footer__mail" :href="mailUrl">
			{{ $t("contactEmail") }}
		</a>
		<div v-if="hasMultipleLanguages" class="footer__language-selector">
			<button
				:class="{
					'footer__language--selected': isLanguageSelected('en')
				}"
				class="footer__language"
				lang="en"
				@click="setLanguage('en')"
			>
				English
			</button>
			<button
				:class="{
					'footer__language--selected': isLanguageSelected('nl')
				}"
				class="footer__language"
				lang="nl"
				@click="setLanguage('nl')"
			>
				Nederlands
			</button>
		</div>
		<hr class="footer__line" />
		<p class="footer__copyright">© 2022 Royal HaskoningDHV</p>
		<router-link
			v-if="$route.name !== 'privacy'"
			:to="{ name: 'privacy' }"
			class="footer__privacy"
		>
			{{ $t("privacyPolicy") }}
		</router-link>
	</footer>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapGetters } from "vuex";

export default {
	name: "AFooter",
	methods: {
		setLanguage(language) {
			if (i18n.locale !== language) {
				i18n.locale = language;
				this.$router.replace({
					...this.$route,
					params: {
						...this.$route.params,
						lang: language
					}
				});
			}
		},
		isLanguageSelected(language) {
			return i18n.locale === language;
		}
	},
	computed: {
		...mapGetters(["hasMultipleLanguages"]),
		mailUrl() {
			return `mailto:${this.$t('contactEmail')}`;
		},
		telephoneUrl() {
			return `tel:${this.$t('contactPhoneNumber')}`;
		}
	},
	i18n: {
		messages: {
			en: {
				privacyPolicy: "Privacy Policy"
			},
			nl: {
				privacyPolicy: "Privacy Policy"
			}
		}
	}
};
</script>

<style>
.footer {
	background-color: var(--secondary-color);
	display: grid;
	padding: 20px calc(50% - 600px);
	color: #ffffff;
	font-family: Verdana;
	font-size: 14px;

	grid-template-columns: auto auto 1fr auto;
	grid-template-areas:
		"help help help help"
		"callus tel mail languages"
		"line line line line"
		"copyright copyright copyright privacy";
}
@media only screen and (max-width: 1300px) {
	.footer {
		padding: 20px 50px;
	}
}
.footer__help {
	grid-area: help;
	font-weight: bold;
	margin-bottom: 5px;
}
.footer__callus {
	grid-area: callus;
	margin-right: 10px;
	margin-bottom: 5px;
}
.footer__mail {
	grid-area: mail;
}
.footer__tel {
	grid-area: tel;
}
.footer__language-selector {
	grid-area: languages;
}
.footer__line {
	grid-area: line;
	margin-top: 20px;
	margin-bottom: 20px;
	border: none;
	height: 1px;
	background-color: #b7b7b7;
}
.footer__copyright {
	grid-area: copyright;
	font-family: TheSansOsF;
	font-weight: bold;
}
.footer__privacy {
	grid-area: privacy;
	font-family: TheSansOsF;
	font-weight: bold;
	text-align: right;
}

.footer__language {
	margin-left: 20px;
	opacity: 0.6
}
.footer__language--selected {
	opacity: 1.0;
}

.footer__mail,
.footer__tel {
	margin-left: 20px;
}
.footer__privacy,
.footer__mail,
.footer__tel {
	text-decoration: none;
	color: #ffffff;
	display: block;
}

.footer__privacy:hover,
.footer__mail:hover,
.footer__tel:hover {
	text-decoration: underline;
}

/* This breakpoint has been discussed with the designer, so the page looks good */
@media only screen and (max-width: 880px) {
	.footer {
		grid-template-columns: auto 1fr auto;
		grid-template-areas:
			"help help help"
			"callus callus callus"
			"tel mail languages"
			"line line line"
			"copyright copyright privacy";
	}
	.footer__tel {
		margin-left: 0;
	}
}
/* This breakpoint has been discussed with the designer, so the page looks good */
@media only screen and (max-width: 580px) {
	.footer {
		grid-template-columns: 1fr auto;
		grid-template-areas:
			"help help"
			"callus callus"
			"tel tel"
			"mail mail"
			"line line"
			"languages privacy"
			"copyright copyright";
		padding: 20px 25px 14px;
	}
	.footer__mail {
		margin-left: 0;
	}
	.footer__language {
		margin-left: 0;
		margin-right: 20px;
	}
	.footer__copyright {
		text-align: center;
		margin-top: 15px;
	}
}
</style>
